<template>
  <div class="faq">
    <section class="faq__hero">
      <div class="faq__hero-overlay" />
      <div class="faq__hero-content">
        <h1>Questions fréquentes</h1>
      </div>
    </section>

    <section class="faq__content">
      <div class="faq__inner">
        <div class="faq__list">
          <div
            v-for="(item, index) in questions"
            :key="index"
            class="faq__item"
          >
            <button
              class="faq__question"
              @click="toggle(index)"
            >
              <span>{{ item.q }}</span>
              <span
                class="faq__icon"
                :class="{ 'faq__icon--open': openIndex === index }"
              >+</span>
            </button>
            <div
              class="faq__answer"
              :class="{ 'faq__answer--open': openIndex === index }"
            >
              <p>{{ item.a }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref } from "vue";

const openIndex = ref(null)

function toggle(index) {
  openIndex.value = openIndex.value === index ? null : index
}

const questions = [
  {
    q: "À quelle heure faut-il arriver au château ?",
    a: "À 17h30 pour la cérémonie. Inutile d'arriver plus tôt, le château ouvrira ses portes à 17h00 précise. Plus tard, vous risqueriez de rater le début de la cérémonie…",
  },
  {
    q: "Peut-on dormir au château ?",
    a: "Non, le château ne propose pas de couchage. De nombreux logements sont disponibles à proximité pour tous les budgets.",
  },
  {
    q: "Pourquoi faut-il loger dans un rayon de 20 km ?",
    a: "Pour pouvoir profiter du service de taxis gratuit, disponible toute la nuit et le dimanche matin pour revenir sur le lieu du mariage.",
  },
  {
    q: "Doit-on respecter le dress code ?",
    a: "Le dress code n’est pas une obligation mais nous serions très touchés qu’il soit respecté pour avoir une harmonie visuelle et de belles photos de mariage.",
  },
  {
    q: "Y aura-t-il un brunch le lendemain ?",
    a: "Oui, à 11h au château, et on espère vous y voir !",
  },
  {
    q: "Puis-je venir accompagné(e) ?",
    a: "Nous avons la chance d'être très bien entourés et ne pourrons pas accueillir d'invités supplémentaires.",
  },
  {
    q: "Comment puis-je indiquer mon régime alimentaire ?",
    a: "Vous pouvez l'indiquer via le questionnaire qui permet de confirmer votre présence.",
  },
  {
    q: "Puis-je m'habiller en blanc pour la cérémonie du 13 juin ?",
    a: "Non, le blanc et ses nuances seront réservés à la mariée. En cas de doute, n'hésitez pas à demander conseil ou confirmer votre tenue auprès de nos témoins.",
  },
  {
    q: "Puis-je m'habiller en blanc pour le brunch du 14 juin ?",
    a: "Oui, nous proposons de switcher par rapport à la veille : les mariés en couleurs et les invités en blanc ou ses nuances (blanc cassé, neige, lin, crème, beige clair, etc.).",
  },
]
</script>

<style lang="scss" scoped>
@import "../base/mixins";

.faq__hero {
  position: relative;
  height: 50vh;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-image: url('../images/IMG-20230310-WA0156.jpg');
  background-size: 100%;
  background-position: 50% 61%;

  @media (max-width: $bp-desktop) {
  background-position: 50% 65%;
  }

  @media (max-width: $bp-tablet) {
  background-position: 50% 70%;
  }

  @media (max-width: $bp-mobile) {
    max-height: 300px;
    min-height: 300px;
  }
}

.faq__hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba($color-text-primary, 0.3);
}

.faq__hero-content {
  position: relative;
  z-index: 1;

  h1 {
    color: $color-white;
    font-weight: 300;
    letter-spacing: 0.05em;
    text-shadow: 0 12px 12px rgba(0, 0, 0, 1);
  }
}

.faq__content {
  @include section-padding;
}

.faq__inner {
  @include container;
  max-width: $container-narrow;
}

.faq__list {
  display: flex;
  flex-direction: column;
}

.faq__item {
  border-bottom: 1px solid $color-border;
}

.faq__question {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: $spacing-element;
  padding: $spacing-block-sm 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  @include heading;
  font-size: 1.05rem;
  font-weight: 400;

  &:hover {
    color: $color-accent;
  }
}

.faq__icon {
  flex-shrink: 0;
  font-size: 1.4rem;
  font-weight: 300;
  font-family: $font-heading;
  transition: transform 0.3s;
  color: $color-accent;

  &--open {
    transform: rotate(45deg);
  }
}

.faq__answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;

  &--open {
    max-height: 200px;
    padding-bottom: $spacing-block-sm;
  }

  p {
    @include body-text;
    font-size: 0.95rem;
    color: $color-text-secondary;
  }
}
</style>
